

export class Currency {

  public id: number;
  public currencyId: number;
  public code: string;
  public name: string;
  public symbol: string;
}
